import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const firstRoute = useRef(true);
  const [announcement, setAnnouncement] = useState("");

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
    const frame = window.requestAnimationFrame(() => {
      const main = document.getElementById("main-content");
      const heading = main?.querySelector("h1");
      setAnnouncement(heading?.textContent || "Page loaded");
      if (!firstRoute.current) main?.focus({ preventScroll: true });
      firstRoute.current = false;
    });
    return () => window.cancelAnimationFrame(frame);
  }, [pathname]);

  return <span className="sr-only" aria-live="polite" aria-atomic="true">{announcement}</span>;
};

export default ScrollToTop;
